import {FeatureFlagProvider} from '#/contexts/amplitude-flags-contexts';
import {UncachedTransactionsProvider} from '#/contexts/blockchain-transactions-provider';
import {ClientEnabledFeaturesProvider} from '#/contexts/client-enabled-features-provider';
import {ImportWalletTransactionsProvider} from '#/contexts/import-wallet-transactions-provider';
import {ModalProvider} from '#/contexts/modal-provider';
import {WrappedQueryClientProvider} from '#/contexts/query-client-provider';
import {QueryParamsProvider} from '#/contexts/query-params-provider';
import {UIStatusProvider} from '#/contexts/ui-status-provider';
import {WalletProvider} from '#/contexts/wallet-provider';
import {
  CoinDisplayPreferencesProvider,
  DefaultCoinDisplayPreferencesProvider,
} from '#/hooks/use-coin-display-preferences';
import {DefaultChildren} from '#/utils/utils';
import {wagmiConfig} from '#/wagmi/wagmi-config';
import {FunctionComponent} from 'react';
import {HeadProvider} from 'react-head';
import {BrowserRouter} from 'react-router-dom';
import {WagmiProvider} from 'wagmi';

export const CoreContexts: FunctionComponent<DefaultChildren> = ({children}) => (
  <BrowserRouter>
    <HeadProvider>
      <QueryParamsProvider>{children}</QueryParamsProvider>
    </HeadProvider>
  </BrowserRouter>
);

export const ExchangeContexts: FunctionComponent<DefaultChildren> = ({children}) => {
  return (
    <WagmiProvider config={wagmiConfig} reconnectOnMount={true}>
      <WrappedQueryClientProvider>
        <FeatureFlagProvider>
          <WalletProvider>
            <ClientEnabledFeaturesProvider>
              <UncachedTransactionsProvider>
                <ImportWalletTransactionsProvider>
                  <CoinDisplayPreferencesProvider>
                    <ModalProvider>
                      <UIStatusProvider>{children}</UIStatusProvider>
                    </ModalProvider>
                  </CoinDisplayPreferencesProvider>
                </ImportWalletTransactionsProvider>
              </UncachedTransactionsProvider>
            </ClientEnabledFeaturesProvider>
          </WalletProvider>
        </FeatureFlagProvider>
      </WrappedQueryClientProvider>
    </WagmiProvider>
  );
};

export const EmbedContexts: FunctionComponent<DefaultChildren> = ({children}) => (
  <WrappedQueryClientProvider>
    <DefaultCoinDisplayPreferencesProvider>{children}</DefaultCoinDisplayPreferencesProvider>
  </WrappedQueryClientProvider>
);
